import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";

const CustomRadio = withStyles({
    colorPrimary: {
        color: "var(--color-blur-600)"
    }
})(Radio);

function CustomRadioButton(props) {
    return (
        <CustomRadio {...props}/>
    );
}

CustomRadioButton.propTypes = {};
CustomRadioButton.defaultProps = {};

export default CustomRadioButton;
